import React, { Component } from "react";
import { Container } from "react-bootstrap";
import { Trans } from "react-i18next";

class OtherDetails extends Component {
  render() {
    return (
      <Container>
        <div className="services-content row">
          <h3>
            <Trans i18nKey="common:services.details.title" />
          </h3>
        </div>
        <div className="services-content row">
          <div className="col-6">
            <ul>
              <li>
                <Trans i18nKey="common:services.others.details.item_01" />
              </li>
              <li>
                <Trans i18nKey="common:services.others.details.item_02" />
              </li>
              <li>
                <Trans i18nKey="common:services.others.details.item_03" />
              </li>
              <li>
                <Trans i18nKey="common:services.others.details.item_04" />
              </li>
              <li>
                <Trans i18nKey="common:services.others.details.item_05" />
              </li>
              <li>
                <Trans i18nKey="common:services.others.details.item_06" />
              </li>
            </ul>
          </div>
        </div>
      </Container>
    );
  }
}

export default OtherDetails;
